import React from 'react';
import { CommonNotification } from '../../types';
import { antGrey, runwayColors, tagStyle } from '../styles/globalStyles';
import Space from 'antd/lib/space';
import Icon, { SettingOutlined } from '@ant-design/icons';
import { iconForAppNotificationId } from '../../helpers/displayHelpers';
import Text from 'antd/lib/typography/Text';
import Tag from 'antd/lib/tag';
import PermissionedActionButton from '../HOCs/PermissionedActionButton';
import { RunwayUserAction } from '../../helpers/aclHelpers';

interface NotificationRowProps {
    notification: CommonNotification;
    notificationsEnabled: boolean;
    onClickSettings: (notificationId: string) => void;
    actionType: RunwayUserAction;
    bucketId?: string;
}

const NotificationRow: React.FC<NotificationRowProps> = (props: NotificationRowProps) => {
    const { notification, actionType, bucketId } = props;
    const tagColor = notification.enabled ? runwayColors.statusGreen : antGrey.grey6;
    const notificationsEnabled = props.notificationsEnabled;

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexGrow: 1,
            }}
        >
            <Space size={18} align="center">
                <Icon
                    component={iconForAppNotificationId(notification.id)}
                    style={{
                        fontSize: 16,
                        color: props.notificationsEnabled ? antGrey.grey7 : antGrey.grey5,
                        paddingTop: 4,
                    }}
                />
                <Text type={notificationsEnabled || notification.enabled ? undefined : 'secondary'}>
                    {notification.displayText}
                </Text>
            </Space>
            <Space>
                <Tag
                    color="white"
                    style={{
                        ...tagStyle,
                        fontSize: 10,
                        borderColor: tagColor,
                        color: tagColor,
                        opacity: notificationsEnabled ? 1 : 0.5,
                    }}
                >
                    {notification.enabled ? 'ENABLED' : 'DISABLED'}
                </Tag>
                <PermissionedActionButton
                    actionType={actionType}
                    bucketId={bucketId}
                    ghost
                    disabled={!props.notificationsEnabled}
                    icon={
                        <SettingOutlined
                            style={{ color: props.notificationsEnabled ? antGrey.grey7 : antGrey.grey5 }}
                        />
                    }
                    onClick={() => props.onClickSettings(notification.id)}
                />
            </Space>
        </div>
    );
};

export default NotificationRow;
